export const FETCH_SCORESCHEMESCATEGORY_SUCCESS = 'FETCH_SCORESCHEMESCATEGORY_SUCCESS';
export const FETCH_SCORESCHEMESCATEGORY_REQUEST = 'FETCH_SCORESCHEMESCATEGORY_REQUEST';
export const FETCH_SCORESCHEMESCATEGORY_FAILURE = 'FETCH_SCORESCHEMESCATEGORY_FAILURE';